import React, { Component } from 'react';

export default class ModalBackground extends Component<{ children?: React.ReactNode; className?: string }, {}> {
  state = {};

  render() {
    return <div className={`bg-white modal-background d-flex flex-column ${this.props.className || ''}`}>{this.props.children}</div>;
  }
}
